var React = require('react');

function AddCircleOutline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Add Circle"),React.createElement("path",{"d":"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z","fill":"none","stroke":"currentColor","strokeMiterlimit":"10","strokeWidth":"32","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M256 176v160M336 256H176","key":2})]);
}

AddCircleOutline.defaultProps = {"className":"ionicon","viewBox":"0 0 512 512"};

module.exports = AddCircleOutline;

AddCircleOutline.default = AddCircleOutline;
